import {
    TIMELINE_MONTH_FETCHING,
    TIMELINE_MONTH_FAILED,
    TIMELINE_MONTH_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case TIMELINE_MONTH_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case TIMELINE_MONTH_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case TIMELINE_MONTH_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  